let profile = null;
let profileRequest = { type: "profile", params: [] };
export function getProfile() {
    return profile;
}
export function requestProfile(onGet = () => { }) {
    let xhr = new XMLHttpRequest();
    xhr.open("POST", "/auth/req/", true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            profile = JSON.parse(xhr.responseText);
            onGet(profile);
        }
    };
    let data = JSON.stringify(profileRequest);
    xhr.send(data);
}
export function requestOwnedChoreos(onGet = () => { }) {
    let xhr = new XMLHttpRequest();
    xhr.open("POST", "/auth/bcs/getChoreos/", true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            let sets = JSON.parse(xhr.responseText);
            onGet(sets);
        }
    };
    let data = JSON.stringify(profileRequest);
    xhr.send(data);
}
